export const SET_VALUE = 'SET_VALUE';
export const SET_ERROR = 'SET_ERROR';
export const SET_FOCUSED = 'SET_FOCUSED';
export const SET_TOUCHED = 'SET_TOUCHED';
export const RESET_VALUE = 'RESET_VALUE';
export const REGISTER_REQUIRED_FIELD = 'REGISTER_REQUIRED_FIELD';
